require('./bootstrap');

/** Sweet Alert 2*/
import Swal from 'sweetalert2';

window.errorAlert = function (){
    console.log(app.errors);
    let msg = '';
    for (let index = 0; index < app.errors.length; index++) {
        msg += '<p>' + app.errors[index] + '</p>';
    }
    Swal.fire({
        icon: 'error',
        title: 'Opps revisa tu información',
        html: msg,
        showConfirmButton: false,
        timer: 5000
    })
}

window.successAlert = function (){
    Swal.fire({
        icon: 'success',
        title: 'Operación realizada exitosamente',
        html: '<p>' + app.success + '</p>',
        showConfirmButton: false,
        timer: 5000
    })
}